module.exports = __webpack_public_path__ + "img/diagnosis-report-logo.5825d657.png";